import gql from 'graphql-tag';
import { ResourceFragments } from './resource.fragments';

export class ResourceMutations {
  static createResourceMutation = gql`
    mutation CreateResource($payload: CreateResourcePayload!) {
      createResource(payload: $payload) {
        ...resourceDetailsFragment
      }
    }
    ${ResourceFragments.detailsFragment}
  `;

  static updateResourceMutation = gql`
    mutation UpdateResource($payload: UpdateResourcePayload!) {
      updateResource(payload: $payload) {
        ...resourceDetailsFragment
      }
    }
    ${ResourceFragments.detailsFragment}
  `;

  static copyResourceMutation = gql`
    mutation CopyResourceMutation($id: String!) {
      copyResource(id: $id) {
        ...resourceDetailsFragment
      }
    }
    ${ResourceFragments.detailsFragment}
  `;

  static deleteResourceMutation = gql`
    mutation DeleteResourceMutation($id: String!) {
      deleteResource(id: $id)
    }
  `;

  static deleteResourcesMutation = gql`
    mutation DeleteResourceMutation($ids: [String!]!) {
      deleteResources(payload: { resourceIds: $ids })
    }
  `;

  static implementResourceInDocumentMutation = gql`
    mutation ImplementResourceInDocument($payload: ImplementResourceInDocumentPayload!) {
      implementResourceInDocument(payload: $payload) {
        id
        resourceId
        contentId
        documentId
        inTemplate
      }
    }
  `;

  static implementResourceInTemplateMutation = gql`
    mutation ImplementResourceInTemplate($payload: ImplementResourceInTemplatePayload!) {
      implementResourceInTemplate(payload: $payload) {
        id
        resourceId
        contentId
        documentId
        inTemplate
      }
    }
  `;

  static disconnectResourceMutation = gql`
    mutation DisconnectResource($payload: DisconnectResourcePayload!) {
      disconnectResource(payload: $payload)
    }
  `;

  static createResourceDirectory = gql`
    mutation CreateResourceDirectory($payload: CreateResourceDirectoryInput!) {
      createResourceDirectory(payload: $payload) {
        id
        title
        directory
      }
    }
  `;

  static moveResourcesMutation = gql`
    mutation moveResourcesMutation($ids: [String!]!, $directory: String!) {
      moveResources(payload: { resourceIds: $ids, directory: $directory })
    }
  `;
}
